export { default } from './MultiEnpointSelector';
